export type formatClientNameProps = {
    firstName: string;
    lastName: string;
};

export const formatClientName = (firstName: string, lastName: string) => {
    const formattedClientName = firstName && lastName ? `${firstName} ${lastName}` : "";
    const clientName = formattedClientName.length > 10 ? `${formattedClientName.substring(0, 10)}...` : formattedClientName;

    return clientName;
};



export const isWithinThreePercentRange = (total: number, bankTransactionAmount: string): boolean => {
    // Calculate the 20% difference threshold
    const threePercentDifference = total * 0.03;

    // Calculate the lower and upper bounds for the 20% difference
    const lowerBound = total - threePercentDifference;
    const upperBound = total + threePercentDifference;
    
    // Check if the bank transaction amount is within the 20% range
    const isWithin20Percent = parseFloat(bankTransactionAmount) >= lowerBound && parseFloat(bankTransactionAmount) <= upperBound;

    // Return the result of the check
    return isWithin20Percent;
};